var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHelpCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8 14.667A6.667 6.667 0 1 0 8 1.333a6.667 6.667 0 0 0 0 13.334"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.333 6.333A1.667 1.667 0 1 1 8.941 7.71C8.486 8.021 8 8.448 8 9M8 11.333h.006"
})));
export { SvgHelpCircle as ReactComponent };
export default __webpack_public_path__ + "static/media/HelpCircle.902d4ec3.svg";